<template>
    <div class="app" id="app">
        <!--<iframe  name="frame" id="iframe" :src="hosurl" frameborder="0"></iframe>-->
    </div>
</template>

<script>
    export default {
        data() {
            return{
                userName:'',
                phone:'',
                idCard:'',
                hosUrl:'',
                voucherList:[],
                busiType:''
            }
        },
        mounted(){
            this.voucherList = JSON.parse(localStorage.getItem('voucherList'))
            this.refresh()
        },
        methods: {
            refresh() {
                let hospitalId = this.$store.state.paramModule.param.Hospital.query.selectedHospital.hospitalId
                if (hospitalId === this.constant.HOSPITAL_ID.CDFY){
                    this.goCDFY()
                }else if (hospitalId === this.constant.HOSPITAL_ID.JKSC) {
                    this.goJKSC()
                }else {
                    this.goOther()
                }
            },
            //成大附医跳转页面
            goCDFY() {
                this.url = this.$store.state.paramModule.param.Hospital.query.selectedHospital.jumpAddr
                window.location.replace(this.url)
            },
            //跳转健康四川
            goJKSC() {
                this.hosUrl =this.$store.state.paramModule.param.Hospital.queryUrl //this.$route.query
                window.location.replace(this.hosUrl)
            },
            //跳转其他医院(成都妇女儿童医院跳转)
            goOther() {
                this.url = this.$store.state.paramModule.param.Hospital.query.selectedHospital.jumpAddr
                window.location.replace(this.url)
            }
        }
    }
</script>

<style lang="scss" scoped>
    .app{
        iframe{
            height: 100%;
            width: 100%;
        }
    }
</style>



// WEBPACK FOOTER //
// HospitalPage.vue?5a59ac32